// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bcc78a44","453":"f0521ec1","455":"62e94f7a","889":"fa48cf7e","977":"a7ef828e"}[chunkId] + ".chunk.js";
};